import React from 'react'
import context from '@/context'
import { ModalBody, Form, FormGroup, Label } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import { DropDownList } from '@/components/dropDownList'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import getComponentKey from '@/utils/getComponentKey'

class EditInChargeOfInstitutionsDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      ...props.inChargeOfInstitution,
      institutionKey: getComponentKey()
    }
  }

  render () {
    const props = this.props
    return (
      <ValidationBoundary>
        <BasicHeader title='UsersManagement.InChargeOfInstitution' {...props} />
        <ModalBody>
          <ErrorBoundary>
            <Form>
              <FormGroup>
                <Label>{props.localize('UsersManagement.ResponsibilityType')}</Label>
                <Validator name='responsibilityType' value={this.state.responsibilityType.id} required>
                  <DropDownList
                    dataSource={context.cache.getResponsibilityTypes}
                    onChange={({ value }) => this.setState({ responsibilityType: { id: value }, institution: null, institutionKey: getComponentKey() })}
                    value={this.state.responsibilityType.id}
                    clientSide />
                </Validator>
              </FormGroup>
              <FormGroup>
                <Label>{props.localize('UsersManagement.Institution')}</Label>
                <Validator name='institution' value={this.state.institution} required>
                  <DropDownList
                    disabled={this.state.responsibilityType.id === null}
                    key={this.state.institutionKey}
                    dataSource={request => context.api.institutionService.getInChargeOfInstitutionsLookup(props.userId, this.state.id, (this.state.responsibilityType || {}).id || 0, request)}
                    onChange={({ item }) => this.setState({ institution: item })}
                    value={this.state.institution}
                  />
                </Validator>
              </FormGroup>
            </Form>
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...this.props} onAction={() => this.props.onAction(this.state)} disabled={!isValid} />
        } />
      </ValidationBoundary>
    )
  }
}

export default {
  component: EditInChargeOfInstitutionsDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/editInChargeOfInstitution.js